import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Collapse, Input, Button, Tag } from "antd";
import LoaderTeacher from "../../Loader/Loader_Teacher";
import { useContext } from "react";
import { UserContext } from "../../UserContext";
const { Panel } = Collapse;

const CourseSummary = () => {
  const { course, target, duration } = useParams();
  const [courseData, setCourseData] = useState({});
  const [courseId,setCourseId] = useState(null);
  const [loading, setLoading] = useState(true);
  const { instructorapiuri,token } = useContext(UserContext);
  const navigate = useNavigate();
  const apidata = {
    courseOn: course,
    target: target,
    duration: duration,
  };
  
  
    const fetchCourseData = async () => {
    //   console.log(courseData);
	  
      try {
        const response = await fetch(`${instructorapiuri}/inst/createcourse`, {
					method: "POST",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + token,
					},
					body: JSON.stringify(apidata),
				});
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setCourseData(data.courseData);
		setCourseId(data.courseId)
        setLoading(false);
      } catch (error) {
        console.error("Error fetching course data:", error);
        setLoading(false);
      }
    };

	useEffect(() => {
		fetchCourseData();
	}, []);
    
  
	

  if (loading) {
    return <LoaderTeacher loader_text={"Generating content"}/>;
  }

  const handleEditSubtopic = (
    moduleIndex,
    subModuleIndex,
    newSubModuleName
  ) => {
    setCourseData((prevData) => {
      const newData = { ...prevData };
      newData.courseStructure[moduleIndex].subModules[subModuleIndex] =
        newSubModuleName;
      return newData;
    });
	// console.log(courseData);
  };

  const handleEditQuiz = (moduleIndex, newQuizContent) => {
		setCourseData((prevData) => {
			const newData = { ...prevData };
			newData.courseStructure[moduleIndex].quiz = newQuizContent;
			return newData;
		});
		// console.log(courseData);
};

  const handleAddSubtopic = (moduleIndex, newSubModuleName) => {
		setCourseData((prevData) => {
			const newData = { ...prevData };
			const module = newData.courseStructure[moduleIndex];
			if (!module.subModules) {
				module.subModules = [];
			}
			module.subModules.push(newSubModuleName);
			return newData;
		});
		// console.log(courseData);
	};

	
	 const handleSave = async () => {
		const updatedData = {
			courseData : courseData,
			courseId : courseId
		}
		
			setLoading(true);
			const response = await fetch(
				`${instructorapiuri}/inst/savecourseoutline`,
				{
					method: "POST",
					mode:"cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: "BEARER " + token,
					},
					body: JSON.stringify(updatedData),
				}
			);
			const data = await response.json();
			// console.log(data)
		navigate(`/teacher/courses/content/${courseId}/module/1/submodule/1`);
		};
	

  return (
		<div className="course-summary">
			<div className="section-header">Course Summary</div>
			<div className="course-summary-content">
				<div className="course-summary-title">
					<span>Course Title:</span> {courseData.courseTitle}
				</div>
				<div className="course-summary-description">
					<span>Course Description:</span>
					<br />
					<span className="tabspace"></span>
					{courseData.courseDescription}
				</div>
				<div className="course-summary-objectives">
					{courseData.courseObjective && <span>Course Objectives</span>}
					<ul>
						{courseData.courseObjective &&
							courseData.courseObjective.map((objective, index) => (
								<>
									<li key={index}>{objective}</li>
								</>
							))}
					</ul>
				</div>
				<div className="course-summary-tags">
					{courseData.courseTags && <span>Course Tags</span>}
					<div className="tags-container">
						{courseData.courseTags &&
							courseData.courseTags.map((tag, index) => (
								<>
									<Tag className="tag" key={index}>
										{tag}
									</Tag>
								</>
							))}
					</div>
				</div>
				<div className="course-summary-structure">
					<span>Course Structure</span>
					<Collapse accordion className="structure-content">
						{courseData.courseStructure &&
							courseData.courseStructure.map((module, moduleIndex) => (
								<Panel header={module.moduleName} key={moduleIndex}>
									<div className="submodules">
										<span>Sub Modules:</span>
										<ul>
											{module.subModules &&
												module.subModules.map((submodule, subModuleIndex) => (
													<>
														<li key={subModuleIndex}>
															<Input
																defaultValue={submodule}
																onBlur={(e) =>
																handleEditSubtopic(
																	moduleIndex,
																	subModuleIndex,
																	e.target.value
																)
																}
															/>
														</li>
													</>
												))}
											<li>
												<Button
													type="dashed"
													onClick={() => handleAddSubtopic(moduleIndex, "")}>
													+ Add Subtopic
												</Button>
											</li>
										</ul>
									</div>
									<div className="quizzes">
										<ul>
											{module.quiz && (
												<>
													<span>Quizzes:</span>
													<li>
														<Input
															defaultValue={module.quiz}
															onBlur={(e) =>
																handleEditQuiz(moduleIndex, e.target.value)
															}
														/>
													</li>
												</>
											)}
										</ul>
									</div>
								</Panel>
							))}
					</Collapse>
				</div>
			</div>
			<div className="save-button">
				<Button onClick={async ()=> await handleSave()}>Save</Button>
			</div>
		</div>
	);
};

export default CourseSummary;
